import { candidatesConfig } from '@modules/candidates/candidates.config';
import { retrieve } from '@shared';
import { CandidatesFilter } from '@shared/candidate-filters/candidate-filters.model';

import {
  CandidatesPageFilterActionsUnion,
  CandidatesPageFilterActionTypes,
} from './filters.actions';

export const CandidatesFilterKey = 'candidatesPageFilter';

export const DEFAULT_LOCATION_RADIUS_IN_MILES = 50;

export interface CandidatesPageFilter extends CandidatesFilter {
  statuses: string[];
  offset: number;
}

export const initialState: CandidatesPageFilter = {
  locations: [],
  locationMilesRadius: DEFAULT_LOCATION_RADIUS_IN_MILES,
  keywords: [],
  skills: [],
  companies: [],
  jobTitles: [],
  schools: [],
  fieldOfStudy: [],
  minimumDegree: null,
  experiences: {
    min: candidatesConfig.filter.experience.min,
    max: candidatesConfig.filter.experience.max,
  },
  statuses: [],
  offset: 0,
  warning: false,
  favorites: false,
  silver: false,
  resumeUploadDate: null,
};

/* tslint:disable: no-small-switch*/
export function candidatesPageFilterReducer(
  state = retrieve(CandidatesFilterKey, initialState),
  action: CandidatesPageFilterActionsUnion,
): CandidatesPageFilter {
  switch (action.type) {
    case CandidatesPageFilterActionTypes.Set:
      return {
        ...state,
        ...action.payload,
      };

    case CandidatesPageFilterActionTypes.Clear:
      return initialState;
    default:
      return state;
  }
}
